import React from "react";
import { useParams } from "react-router-dom";
import { cuesApi } from "../imports";
import { updateCue } from "../../api/cue";

export default function CueStatus({ cue, clickable }) {
	let { projectId } = useParams();

	let bgColour;
	let bgColourHover;
	let borderColour;
	let statusColour;
	let statusBorderColour;

	switch (cue.status) {
		case "ready":
			bgColour = "gray-800";
			borderColour = "gray-800";
			bgColourHover = "gray-700";
			statusColour = "bg-gray-800";
			statusBorderColour = "gray-800";
			break;

		case "cued":
			bgColour = "gray-800";
			borderColour = "gray-800";
			bgColourHover = "gray-700";
			statusColour = "bg-gray-800";
			statusBorderColour = "red-600 border-dashed";
			break;

		case "coming":
			bgColour = "gray-700";
			borderColour = "gray-700";
			bgColourHover = "gray-600";
			statusColour = "bg-gray-800";
			statusBorderColour = "red-600";
			break;

		case "onair":
			bgColour = "gray-800";
			borderColour = "gray-800";
			bgColourHover = "gray-700";
			// bgColour = "gray-700";
			// bgColourHover = "bg-gray-600";
			statusColour = "bg-red-500";
			statusBorderColour = "red-500";
			break;

		case "cuedoff":
			bgColour = "gray-700";
			borderColour = "gray-700";
			bgColourHover = "gray-600";
			statusColour = "bg-red-500";
			statusBorderColour = "gray-900  border-dashed";
			break;

		case "going":
			bgColour = "gray-700";
			borderColour = "gray-700";
			bgColourHover = "gray-600";
			statusColour = "bg-gray-800";
			statusBorderColour = "red-500";
			break;

		case "offair":
			bgColour = "gray-800";
			borderColour = "gray-800";
			bgColourHover = "gray-700";
			statusColour = "bg-gray-800";
			statusBorderColour = "gray-800";
			break;

		default:
			bgColour = "gray-800";
			borderColour = "gray-800";
			bgColourHover = "gray-800";
			statusColour = "bg-gray-800";
			statusBorderColour = "gray-800";
			break;
	}

	return (
		<>
			{/* STATUS BAR */}
			<div className="flex gap-2">
				{cue.type === 'section' ?
				''
				: <button
					title="Cue-on/Cue-off air"
					disabled={!clickable}
					style={{
						minWidth: "2rem",
						width: "2rem",
						// height: '1.5rem'
					}}
					className={`rounded border-2 border-${
						clickable ? statusBorderColour : "transparent"
					} transition duration-500 ease-in-out focus:outline-none 
							 ${
									cue.status === "offair" || !clickable
										? "bg-gray-900"
										: statusColour
								}
								
								${
									cue.status === "coming" || cue.status === "going"
										? "animate-pulse"
										: "animate-none"
								}
	
				${cue.status === "onair" && cue.onAirDuration && "animate-pulse-fast"}
							 ${clickable ? "cursor-pointer" : "cursor-default"}
							 ${cue.partOfGroup && "ml-12"}
				`}
					onClick={() => {
						let changeTo;
	
						if (cue.status === "cued") {
							changeTo = "ready";
						} else if (cue.status === "onair") {
							changeTo = "cuedoff";
						} else if (cue.status === "cuedoff") {
							changeTo = "onair";
						} else {
							changeTo = "cued";
						}
	
						cuesApi.updateCue(cue.id, projectId, {
							status: changeTo,
						});
					}}
				></button>}

			{window.location.href.includes('buttons') || cue.type === 'section' ?
				''
				:
				<>
				<div className={[
					"flex flex-col text-xxs font-extrabold",
				].join(' ')}>
					<button className="flex flex-col border-2 border-gray-800 px-1 py-1 rounded h-full items-center justify-center"
						onClick={() => {
							let changeTo;

							if (cue.status === "onair" || cue.status === "cuedoff") {
								changeTo = "going";
							} else if (cue.status === "coming" || cue.status === "going") {
								changeTo = "ready";
							} else {
								changeTo = "coming";
							}

							cuesApi.updateCue(cue.id, projectId, {
								status: changeTo,
							});
						}}
					>
						<span className={[
							"py-1 h-full w-[2.2rem] rounded-t flex items-center justify-center transition-colors",
							['onair', 'coming', 'cuedoff'].includes(cue.status) ? 'text-transparent bg-gray-800' : 'bg-gray-900'
						].join(' ')}
						>OFF</span>
						<span className={[
							"py-1 h-full w-[2.2rem] rounded-b flex items-center justify-center transition-colors",
							['ready', 'going', 'cued'].includes(cue.status) ? 'text-transparent bg-gray-800' : 'bg-red-500'
						].join(' ')}
						>ON</span>
					</button>
				</div>
			</>
			}
			</div>
		</>
	);
}
